export enum Environments {
  LOCAL = 'LOCAL',
  DEVELOPMENT = 'DEV',
  STAGING = 'STAGING',
  SANDBOX = 'SANDBOX',
  PRODUCTION = 'PRODUCTION',
}

export enum NodeEnvironments {
  DEVELOPMENT = 'development',
  PRODUCTION = 'production',
}

export const ENV_VARS = {
  environment: import.meta.env.VITE_ENVIRONMENT as Environments,
  node: import.meta.env.NODE_ENV as NodeEnvironments,
  release: import.meta.env.VITE_RELEASE,
  faqs: import.meta.env.VITE_FAQS_URL,
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL,
  },
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN_HR,
  },
  amplitude: {
    apiKey: import.meta.env.VITE_AMPLITUDE_API_KEY,
  },
  clarity: {
    projectId: import.meta.env.VITE_CLARITY_PROJECT_ID_HR,
  },
  intercom: {
    appId: import.meta.env.VITE_INTERCOM_APP_ID,
  },
  serviceAgreements: {
    privacy: import.meta.env.VITE_PRIVACY_DOCUMENT_URL,
    terms: import.meta.env.VITE_TERMS_DOCUMENT_URL,
  },
  employees: {
    templateUrl: import.meta.env.VITE_IMPORT_USERS_TEMPLATE_URL,
  },
  vouchersIban: import.meta.env.VITE_VOUCHERS_IBAN,
  growthbook: {
    apiHost: import.meta.env.VITE_GROWTHBOOK_API_HOST,
    clientKey: import.meta.env.VITE_GROWTHBOOK_CLIENT_KEY,
  },
  bucket: {
    url: import.meta.env.VITE_BUCKET_URL,
  },
  googleMaps: {
    apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
    mapId: import.meta.env.VITE_GOOGLE_MAPS_MAP_ID,
  },
} as const;
